import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Ensure BASE_URL is correctly defined
import { useNavigate } from 'react-router-dom';

const BrandWiseList = () => {
    // State for brand-wise data and filtered data
    const [brandWiseData, setBrandWiseData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    // Fetch data from API when the component mounts
    useEffect(() => {
        fetch(`${BASE_URL}brandwise`)
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'success') {
                    setBrandWiseData(data.data);
                    setFilteredData(data.data); // Initialize filtered data
                } else {
                    console.error('Error fetching BrandWise data.');
                }
            })
            .catch((error) => console.error('Error fetching BrandWise data:', error));
    }, []);

    // Handle search term changes
    const handleSearchChange = (event) => {
        const term = event.target.value;
        setSearchTerm(term);

        // Filter data based on the search term
        const filtered = brandWiseData.filter((item) =>
            item.brand_name.toLowerCase().includes(term.toLowerCase())
        );
        setFilteredData(filtered);
    };

    // Navigate to the edit page
    const handleEdit = (id) => {
        navigate(`/EditBrandWise/${id}`);
    };

    // Navigate to the add page
    const handleAdd = () => {
        navigate('/AddBrandWise');
    };

    // Handle item deletion
    const handleDelete = (id) => {
        if (window.confirm('Are you sure you want to delete this entry?')) {
            fetch(`${BASE_URL}brandwise/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.status === 1) {
                        // Update state after deletion
                        setBrandWiseData(brandWiseData.filter((item) => item.id !== id));
                        setFilteredData(filteredData.filter((item) => item.id !== id));
                    }
                })
                .catch((error) => console.error('Error deleting entry:', error));
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Brand Wise Discounts</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h4 className="card-title">Brand Wise Discount List</h4>
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary" onClick={handleAdd}>
                                            Add Brand Discount
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="mb-3">
                                    <label htmlFor="searchTerm" className="form-label">Search by Brand Name</label>
                                    <input
                                        type="text"
                                        id="searchTerm"
                                        className="form-control"
                                        placeholder="Search brand name"
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                    />
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Description</th>
                                                <th>Date</th>
                                                <th>Brand Code</th>
                                                <th>Brand Name</th>
                                                <th>Retailer Discount (%)</th>
                                                <th>Wholesaler Discount (%)</th>
                                                <th>Dealer Discount (%)</th>
                                                <th className="text-end">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredData.length > 0 ? (
                                                filteredData.map((item, index) => (
                                                    <tr key={item.id}>
                                                        <td>{index + 1}</td>
                                                        <td>{item.description || 'N/A'}</td>
                                                        <td>{new Date(item.date).toLocaleDateString()}</td>
                                                        <td>{item.brand_code || 'N/A'}</td>
                                                        <td>{item.brand_name || 'N/A'}</td>
                                                        <td>{item.retailer_discount || 'N/A'}</td>
                                                        <td>{item.wholesaler_discount || 'N/A'}</td>
                                                        <td>{item.dealer_discount || 'N/A'}</td>
                                                        <td className="text-end">
                                                            <button
                                                                className="btn btn-success"
                                                                onClick={() => handleEdit(item.id)}
                                                            >
                                                                Edit
                                                            </button>
                                                            <button
                                                                className="btn btn-danger ms-2"
                                                                onClick={() => handleDelete(item.id)}
                                                            >
                                                                Delete
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="9" className="text-center">
                                                        No records found.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default BrandWiseList;
